const ReviewerSessionsScheduled = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-sessions/ReviewerSessionsScheduled.vue"
  );
const ReviewerSessionsSuggested = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-sessions/ReviewerSessionsSuggested.vue"
  );
const ReviewerSessionsCancelled = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/reviewer-sessions/ReviewerSessionsCancelled.vue"
  );
export default [
  {
    path: "",
    name: "reviewer-sessions",
    redirect: { name: "reviewer-sessions-suggested" },
  },
  {
    path: "proposed",
    name: "reviewer-sessions-suggested",
    component: ReviewerSessionsSuggested,
  },
  {
    path: "programmed",
    name: "reviewer-sessions-scheduled",
    component: ReviewerSessionsScheduled,
  },
  {
    path: "cancelled",
    name: "reviewer-sessions-cancelled",
    component: ReviewerSessionsCancelled,
  },
];
